import { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { apiClient } from '../../api/client';
import { AuthRequiredModal } from '../modals/AuthRequiredModal';
import { getFingerprint } from '../../utils/fingerprint';

interface Props {
  children: React.ReactNode;
}

/**
 * Wraps routes that should be inaccessible to banned fingerprints/IPs.
 * Waits for fingerprint to be set on the API client before calling ban-check,
 * otherwise the X-Fingerprint header may not be ready on first load.
 */
export function BanGate({ children }: Props) {
  const [status, setStatus] = useState<'checking' | 'allowed' | 'banned' | 'limit_reached'>('checking');

  useEffect(() => {
    getFingerprint().then(() =>
      apiClient
        .get('/api/v1/ban-check')
        .then(res => {
          if (res.data.banned) setStatus('banned');
          else if (res.data.limit_reached) setStatus('limit_reached');
          else setStatus('allowed');
        })
        .catch(() => setStatus('allowed')) // fail open — never block on network error
    );
  }, []);

  if (status === 'checking') return null;
  if (status === 'banned') return <Navigate to="/" replace />;
  if (status === 'limit_reached') return (
    <AuthRequiredModal isOpen action="limit" />
  );
  return <>{children}</>;
}
